/* unplugin-vue-components disabled */import { render } from "./SaasVersion.vue?vue&type=template&id=71621c8a"
const script = {}

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__